import React from "react";
import PrintableAddForm from "@/components/PrintableAddForm";

/**
 * Blank Add-supplier form. Handed out when onboarding a new supplier so
 * the person collecting details (phone call, first site visit, trade
 * show) can capture everything on paper before typing it into the app.
 * Field order mirrors the Suppliers add dialog for a straight transcribe.
 */

const ROWS = [
  [
    { label: "Supplier name (trading name)", flex: 3 },
    { label: "Category (e.g. resins, tools, machinery, courier)", flex: 3 },
  ],
  [
    { label: "Main contact — name", flex: 3 },
    { label: "Role / job title", flex: 2 },
  ],
  [
    { label: "Phone (business hours)", flex: 2 },
    { label: "After-hours / mobile", flex: 2 },
    { label: "Fax (if applicable)", flex: 2 },
  ],
  [
    { label: "Orders email", flex: 3 },
    { label: "Accounts email", flex: 3 },
  ],
  [
    { label: "Website", flex: 3 },
    { label: "ABN / VAT (tax number)", flex: 2 },
  ],
  [
    { label: "Postal address — street", flex: 4 },
    { label: "Suburb / city", flex: 2 },
    { label: "Postcode", flex: 1 },
  ],
  [
    { label: "Delivery lead time (days)", flex: 1 },
    { label: "Payment terms (COD / 7d / 30d / EOM)", flex: 2 },
    { label: "Preferred currency", flex: 1 },
    { label: "Account number (our ref)", flex: 2 },
  ],
  [
    { label: "Products / services they supply", flex: 5 },
  ],
  [
    { label: "Alternate contact — name", flex: 3 },
    { label: "Alternate contact — phone / email", flex: 3 },
  ],
];

const SupplierAddPrint = () => (
  <PrintableAddForm
    pageTitle="Add supplier"
    toolbarHint="Take one form per new supplier when meeting reps or setting up new accounts. Star field is the orders email — most important for POs."
    eyebrow="Podlab · Suppliers"
    scope="Suppliers register"
    formTitle="Add-supplier sheet"
    rows={ROWS}
    starField={{ label: "Primary orders email" }}
    noteLabel="Notes · discounts · minimum order · anything worth remembering"
    testid="supplier-add-print-page"
    copies={2}
  />
);

export default SupplierAddPrint;
